import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getPoAccessRole = createApi(`getPoAccessRoleSlice`, "GET");

const getPoAccessRoleSlice = createSlice({
  name: 'getPoAccessRoleSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPoAccessRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPoAccessRole.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPoAccessRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getPoAccessRoleSlice.reducer;
